<template>
  <div class="slider-buttons">
    <div
      :class="[
        classButtons ? classButtons : 'slider-buttons__button',
        classButtonPrev ? classButtonPrev : 'slider-buttons__button-prev',
      ]"
      onclick="this.nextElementSibling.__vue__.$parent.onPrevSlide();"
    />
    <swiper ref="refSwiper" :options="options" class="slider-buttons__content">
      <slot />
    </swiper>
    <div
      :class="[
        classButtons ? classButtons : 'slider-buttons__button',
        classButtonNext ? classButtonNext : 'slider-buttons__button-next',
      ]"
      onclick="this.previousElementSibling.__vue__.$parent.onNextSlide();"
    />
  </div>
</template>
<script>
import {Swiper} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'SliderButtons',
  components: {
    Swiper,
  },
  props: {
    options: {
      type: Object,
      default: () => {},
    },
    owner: Object,
    classButtons: String,
    classButtonPrev: String,
    classButtonNext: String,
  },
  mounted() {
    this.$nextTick(() => this.$refs['refSwiper'].$swiper.update());
  },
  methods: {
    onNextSlide() {
      this.$refs['refSwiper'].$swiper.slideNext();
      if (this.owner) this.owner.$forceUpdate();
    },
    onPrevSlide() {
      this.$refs['refSwiper'].$swiper.slidePrev();
      if (this.owner) this.owner.$forceUpdate();
    },
  },
};
</script>
<style scoped>
.slider-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.slider-buttons__content {
  margin-left: 0;
  margin-right: 0;
  width: 100%;
  height: 100%;
}
.slider-buttons__button {
  width: 76px;
  height: 76px;
  cursor: pointer;
  transition: 0.4s;
  background-color: transparent;
}
.slider-buttons__button-prev {
  background-image: url(~IMAGES/icons/prev.svg);
}
.slider-buttons__button-prev:hover {
  transform: translate(-10px);
}
.slider-buttons__button-next {
  background-image: url(~IMAGES/icons/next.svg);
}
.slider-buttons__button-next:hover {
  transform: translate(10px);
}
</style>
